const FinancialPolicy = () => {
    return (
        <div className="text-black">
            <p className="font-medium mb-1">
                Thank you for choosing Retina Specialty Institute. We are committed to the treatment, preservation, and advancement of your retina care. Please understand that payment of your bill is considered part of your retina care. The following is a statement of our policy, which we require that you read and sign before being seen by one of our physicians.
            </p>

            <h3 className="font-bold text-lg mb-1">Your Responsibility:</h3>
            <p className="font-medium mb-1">
                You are financially responsible for the services we provide to you. As such, we require that the patient or legal guardian either pay or arrange for payment at the time of service. As a courtesy to you, we will file a claim to your insurance plan(s). Please remember that your insurance benefits are a contract between you and your insurance carrier. If there is a discrepancy with payment of our claims, we may look to you for assistance in expediting our claims in a timely manner.
            </p>

            <h3 className="font-bold text-lg mb-1">Non-Covered Service Condition</h3>
            <p className="font-medium mb-1">
                Since we are a specialty practice, some procedures that may be performed in your treatment plan could be deemed non-covered by your insurance plan. In the event that these services are determined non-covered, it is your responsibility to pay for the services rendered. Our patient financial counselors are available to review these out-of-pocket expenses with you prior to services being rendered.
            </p>

            <h3 className="font-bold text-lg mb-1">Prior Balance</h3>
            <p className="font-medium mb-4">
                Patients with a balance from prior dates of service will be required to pay that balance in full before being seen by our physicians. If the prior balance cannot be paid in full, you will be asked to speak to our patient financial counselors to make payment arrangements based on our payment policy prior to being seen by one of our physicians.
            </p>

            <h3 className="font-bold text-lg mb-1">Self-Pay Patients</h3>
            <p className="font-medium mb-1">
                You will be expected to pay for the balance in full at the time of service.
            </p>

            <h3 className="font-bold text-lg mb-1">Returned Checks</h3>
            <p className="font-medium mb-4">
                We will assess a fee on all checks that have been returned by our bank for "non-sufficient funds" per applicable state law. Payment of this fee must be made prior to your next appointment.
            </p>

            <h3 className="font-bold text-lg mb-1">Collection Agency</h3>
            <p className="font-medium mb-1">
                Prompt payment of patient balances is expected per the terms of this agreement. We will use an outside collection agency for patient balances as we deem necessary. Failure to resolve outstanding patient balances may result in discharge from care by our physicians. Prior balances must be resolved before the practice will provide new services.
            </p>

            <p className="font-medium mb-1">
                I have read and understand the financial policy of Retina Specialty Institute. I agree and understand the terms and conditions of this policy and agree that any questions I have, have been answered by the patient financial counselors to the best of my understanding.
            </p>
        </div>
    );
};

export default FinancialPolicy;
